import { useAuth } from '../contexts/AuthContext';
import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function PendingApproval() {
  const { currentUser, userProfile, logout } = useAuth();
  const location = useLocation();
  const [pendingUserData, setPendingUserData] = useState(null);

  // Get user data from navigation state if user was signed out after registration
  useEffect(() => {
    if (location.state?.userData) {
      setPendingUserData(location.state.userData);
    }
  }, [location.state]);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          className="mx-auto h-12 w-auto"
          src="/apn-logos/APN-Tag-blue.png"
          alt="APN Logo"
        />
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Account Pending Approval
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
              <svg className="h-6 w-6 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            
            <h3 className="mt-4 text-lg font-medium text-gray-900">
              Thank you for registering!
            </h3>
            
            <div className="mt-4 text-sm text-gray-600">
              <p className="mb-4">
                Your account has been created successfully. However, it's currently pending approval from our administrators.
              </p>
              
              <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mb-4">
                <div className="text-left">
                  <h4 className="font-medium text-blue-900 mb-2">Account Details:</h4>
                  <ul className="space-y-1 text-blue-800">
                    <li><strong>Name:</strong> {userProfile?.displayName || pendingUserData?.displayName || 'Not available'}</li>
                    <li><strong>Email:</strong> {currentUser?.email || pendingUserData?.email || 'Not available'}</li>
                    <li><strong>Company:</strong> {userProfile?.company || pendingUserData?.company || 'Not provided'}</li>
                    <li><strong>Status:</strong> <span className="capitalize">{userProfile?.status || 'pending'}</span></li>
                  </ul>
                </div>
              </div>
              
              <p className="mb-4">
                You'll receive an email notification once your account has been approved. This typically takes 1-2 business days.
              </p>
              
              <div className="bg-gray-50 border border-gray-200 rounded-md p-4 mb-4">
                <h4 className="font-medium text-gray-900 mb-2">What happens next?</h4>
                <ul className="text-left text-gray-700 space-y-1 text-sm">
                  <li>• Our team will review your application</li>
                  <li>• You'll receive an email when approved</li>
                  <li>• Once approved, you can access all member features</li>
                  <li>• You can then choose a membership tier</li>
                </ul>
              </div>
              
              <p className="text-xs text-gray-500">
                If you have any questions, please contact us at{' '}
                <a href="mailto:support@the-apn.com" className="text-apn-blue hover:text-apn-dark-blue">
                  support@the-apn.com
                </a>
              </p>
            </div>
            
            <div className="mt-6">
              <button
                onClick={handleLogout}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-apn-blue hover:bg-apn-dark-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-apn-blue"
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
